'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _components = require('components');

var _GenericSettings = require('redux/modules/GenericSettings');

var _fetchStatusTypes = require('constants/fetchStatusTypes');

var STATUS = _interopRequireWildcard(_fetchStatusTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var mstp = function mstp(state) {
  return {
    codedToken: state.auth.codedToken,
    genericSettings: state.genericSettings,
    genericSettingsStatus: state.genericSettings.status.genericSettingsStatus,
    STATUS: STATUS
  };
};

var mdtp = {
  getGenericSettings: _GenericSettings.getGenericSettings.base,
  getStorageOptions: _GenericSettings.getStorageOptions.base,
  getConfiguration: _GenericSettings.getConfiguration.base
};

exports.default = (0, _reactRedux.connect)(mstp, mdtp)(_components.Configuration);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Configuration/Configuration.js
// module id = 1623
// module chunks = 0